import React from 'react'

const Separator: React.FC = () => {
  return <div className="cmp-separator"></div>
}

export default Separator
